import { render, staticRenderFns } from "./EmployeeResources.vue?vue&type=template&id=2156a704&scoped=true"
import script from "./EmployeeResources.vue?vue&type=script&lang=js"
export * from "./EmployeeResources.vue?vue&type=script&lang=js"
import style0 from "./EmployeeResources.vue?vue&type=style&index=0&id=2156a704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156a704",
  null
  
)

export default component.exports